// Reemplaza con compras reales de tu plataforma antes de publicar.
export const recentBuyers = [
  { name: 'María G.', city: 'Bogotá', country: 'Colombia', time: 'hace 2 minutos' },
  { name: 'Javier R.', city: 'Madrid', country: 'España', time: 'hace 4 minutos' },
  { name: 'Lucía M.', city: 'Buenos Aires', country: 'Argentina', time: 'hace 6 minutos' },
  { name: 'Carlos P.', city: 'Ciudad de México', country: 'México', time: 'hace 7 minutos' },
  { name: 'Ana S.', city: 'Santiago', country: 'Chile', time: 'hace 9 minutos' },
  { name: 'Diego F.', city: 'Lima', country: 'Perú', time: 'hace 11 minutos' },
  { name: 'Valentina T.', city: 'Montevideo', country: 'Uruguay', time: 'hace 13 minutos' },
  { name: 'Andrés L.', city: 'Miami', country: 'Estados Unidos', time: 'hace 15 minutos' },
  { name: 'Sofía B.', city: 'Quito', country: 'Ecuador', time: 'hace 18 minutos' },
  { name: 'Miguel A.', city: 'Barcelona', country: 'España', time: 'hace 21 minutos' },
  { name: 'Camila V.', city: 'Caracas', country: 'Venezuela', time: 'hace 24 minutos' },
  { name: 'Pablo D.', city: 'Asunción', country: 'Paraguay', time: 'hace 27 minutos' },
]
